export const FromScratchIcon: React.FC = () => (
  <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M17.9186 2.29102C17.877 12.7593 22.967 18.6977 34.5853 18.9577C23.8103 18.916 18.4653 24.6927 17.9186 35.6243C17.8136 25.3127 13.2053 18.9427 1.25195 18.9577C11.9453 18.8077 17.877 13.646 17.9186 2.29102Z'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M31.6875 2.29102V8.95768'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M28.3535 5.625H35.0202' stroke='#1F74B6' strokeWidth='2.25' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M35.416 31.041V37.7077' stroke='#1F74B6' strokeWidth='2.25' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M32.084 34.375H38.7507' stroke='#1F74B6' strokeWidth='2.25' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)
